import { setReloadReason } from 'application/wt-debugger';
import { Component, ReactNode } from 'react';
import Error from 'styleguide/Error';
import { forceHardReload } from 'utility/utils';

type State = {
  error?: any;
};

type Props = {
  children: ReactNode;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    this.setState({ error });
  }

  render() {
    const { error } = this.state;

    if (error) {
      const errorString = error?.toString?.().toLowerCase() || '';

      const isLazyLoadingError =
        errorString.includes('chunkloaderror') ||
        errorString.includes('failed to fetch dynamically imported module') ||
        errorString.includes('loading chunk');

      if (isLazyLoadingError) {
        setReloadReason(window.location.href, error);

        // Force a hard reload and clear cache for chunk loading errors
        // This ensures we get fresh JavaScript bundles
        if (window.location.href.includes('/sign-in')) {
          // If we're already on sign-in page, force a complete page refresh
          forceHardReload();
        } else {
          // For other pages, reload and redirect to sign-in
          window.location.href = '/sign-in';
        }

        return null;
      }

      return <Error text={error.message} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
